import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Col } from 'react-bootstrap';
import CryptoRow from './CryptoRow';
import CryptoModal from './CryptoModal';

export default class CryptoTable extends Component {
  /*
    This component is listing cryto currencies.
  */

  constructor(props) {
    super(props);

    this.state = {
      cryptos: props.cryptos,
      show: false
    };
  }

  showModal = crypto => {
    // Show the modal and set the modal to display the equity clicked.
    this.setState({ show: true, modalCrypto: crypto });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  render() {
    return (
      <div>
        <p className="row-info"> Klikk på en rad for mer info </p>
        <Col md={12}>
          <Table hover responsive size="sm">
            <thead>
              <tr>
                <th>Navn</th>
                <th className="hide-on-500px">Oppdatert</th>
                <th>Siste 24 timer</th>
                <th>Kurs NOK</th>
              </tr>
            </thead>
            <tbody>
              {this.state.cryptos.map((crypto, i) => (
                <CryptoRow
                  key={i}
                  showModal={() => this.showModal(crypto)}
                  crypto={crypto}
                />
              ))}
            </tbody>
          </Table>
        </Col>
        <CryptoModal
          show={this.state.show}
          hide={this.hideModal}
          crypto={this.state.modalCrypto}
        />
      </div>
    );
  }
}

CryptoTable.propTypes = {
  cryptos: PropTypes.arrayOf(PropTypes.object)
};
